import { IAppState } from '../../../AppModulesWrapper';

export const selectRecommendedDepositAmount = (state: IAppState): number => {
  return state.servicePickerWidget.balance.recommendedDepositAmount;
};
